import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Download',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-miterlimit": "10", d: "M3 15v5c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-5" }
      }), h("path", {
        attrs: { d: "M15.9 9H14V2h-4v7H8.1c-.5 0-.7.5-.4.8l3.9 4.7c.2.2.6.2.8 0l3.9-4.7c.3-.3.1-.8-.4-.8z" }
      })]
    );
  }
};